import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, errMsg } from "../api";
import { Brand } from "../components/Brand";
import { Btn, Field, Input, Notice, Select } from "../components/ui";

export function Register({ realm }: { realm: "pf" | "pj" }) {
  const nav = useNavigate();
  const [displayName, setDisplayName] = useState("");
  const [tenantName, setTenantName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [currency, setCurrency] = useState<"BRL" | "USD">("BRL");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api("POST", `/api/${realm}/auth/register`, { displayName, tenantName: realm === "pj" ? tenantName : undefined, email, password, currency });
      nav(`/${realm}/entrar`, { replace: true });
    } catch (e2) { setErr(errMsg(e2)); } finally { setBusy(false); }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-card card">
        <Brand />
        <h1>Criar usuário — {realm === "pf" ? "Pessoa Física" : "Pessoa Jurídica"}</h1>
        <p className="muted" style={{ marginTop: 0 }}>Este cadastro cria um usuário com credenciais exclusivas e dados separados dos demais usuários.</p>
        {err && <Notice kind="error">{err}</Notice>}
        <form onSubmit={submit}>
          <Field label="Seu nome"><Input required value={displayName} onChange={(e) => setDisplayName(e.target.value)} /></Field>
          {realm === "pj" && <Field label="Razão social / nome da empresa"><Input required value={tenantName} onChange={(e) => setTenantName(e.target.value)} /></Field>}
          <Field label="E-mail"><Input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          <Field label="Senha (mínimo 10 caracteres, com letras e números)"><Input type="password" autoComplete="new-password" required minLength={10} value={password} onChange={(e) => setPassword(e.target.value)} /></Field>
          <Field label="Moeda principal">
            <Select value={currency} onChange={(e) => setCurrency(e.target.value as "BRL" | "USD")}>
              <option value="BRL">Real (BRL)</option>
              <option value="USD">Dólar (USD)</option>
            </Select>
          </Field>
          <Btn type="submit" block disabled={busy}>Criar usuário</Btn>
        </form>
        <p className="muted" style={{ textAlign: "center", marginBottom: 0 }}>Já tem conta? <Link to={`/${realm}/entrar`}>Entrar</Link></p>
      </div>
    </div>
  );
}
